export const dataTableTouchTargetClassName =
  'relative before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-11 before:w-full before:min-w-11 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-[inherit] before:content-[""]';
